"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unauthenticatedErrorLink = exports.splitTransportLink = exports.refreshTokenRequiringLink = exports.isSubscription = exports.httpLink = exports.graphqlWsLink = exports.errorLink = exports.accessTokenRequiringLink = exports.accessTokenFetchingLink = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _client = require("@apollo/client");
var _graphqlWs = require("graphql-ws");
var _subscriptions = require("@apollo/client/link/subscriptions");
var _jsTools = require("@airportlabs/js-tools");
var _utilities = require("@apollo/client/utilities");
var _error = require("@apollo/client/link/error");
var _apolloLinkContext = require("apollo-link-context");
var _TokenFetchLink = _interopRequireDefault(require("./TokenFetchLink"));
var _redirectToLoginIfNoAccessToken = _interopRequireDefault(require("./auth/redirectToLoginIfNoAccessToken"));
var _redirectToLoginIfNoRefreshToken = _interopRequireDefault(require("./auth/redirectToLoginIfNoRefreshToken"));
var _redirectToLogout = _interopRequireDefault(require("./auth/redirectToLogout"));
var _tokens = require("./auth/tokens");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var GRAPHQL_MIDDLEWARE_URL = (0, _jsTools.getEnv)("REACT_APP_GRAPHQL_MIDDLEWARE_URL");
var IAM_SCOPE = (0, _jsTools.getEnv)("REACT_APP_IAM_SCOPE", {
  isRequired: false
});
var socketRef = {
  current: null
};
var getExtraHeaders = function getExtraHeaders() {
  var authorization = (0, _tokens.getAccessToken)();
  return _objectSpread({
    scope: IAM_SCOPE
  }, authorization ? {
    authorization: authorization
  } : {});
};

// Checks whether a specific operation is a Subscription or not
var isSubscription = exports.isSubscription = function isSubscription(_ref) {
  var query = _ref.query;
  var _ref2 = (0, _utilities.getMainDefinition)(query) || {},
    kind = _ref2.kind,
    operation = _ref2.operation;
  return kind === "OperationDefinition" && operation === "subscription";
};

// Redirects app to login if no REFRESH_TOKEN
var refreshTokenRequiringLink = exports.refreshTokenRequiringLink = new _client.ApolloLink(function (operation, forward) {
  (0, _redirectToLoginIfNoRefreshToken["default"])();
  return forward(operation);
});

// Redirects app to login if no ACCESS_TOKEN
var accessTokenRequiringLink = exports.accessTokenRequiringLink = new _client.ApolloLink(function (operation, forward) {
  (0, _redirectToLoginIfNoAccessToken["default"])();
  return forward(operation);
});
var unauthenticatedErrorLink = exports.unauthenticatedErrorLink = (0, _error.onError)(function (_ref3) {
  var graphQLErrors = _ref3.graphQLErrors;
  if (!graphQLErrors) {
    return;
  }
  if (graphQLErrors.some(function (_ref4) {
    var message = _ref4.message;
    return /code = Unauthenticated/.test(message) && (_jsTools.authConsole.log("Unauthenticated code found. Redirecting to logout.", message), true);
  })) {
    (0, _redirectToLogout["default"])({
      withBack: true
    });
  }
});

// Fetches an access token if none available.
// Logs the user out if there's any error fetching the access token.
var accessTokenFetchingLink = exports.accessTokenFetchingLink = new _TokenFetchLink["default"]({
  isTokenValid: _tokens.getAccessToken,
  // ApolloProvider redirects to login if missing REFRESH_TOKEN, so this should
  // only throw if REFRESH_TOKEN is invalidated during session
  fetchAccessToken: _tokens.fetchAccessToken.bind(void 0, {
    throwIfNoRefreshToken: true,
    onNewAccessToken: function onNewAccessToken() {
      var _socketRef$current;
      if (((_socketRef$current = socketRef.current) === null || _socketRef$current === void 0 ? void 0 : _socketRef$current.readyState) !== WebSocket.OPEN) {
        return;
      }
      // Close the socket each time a new access token is fetched. That will
      // trigger a new connection which will refresh the connection params. This
      // is needed in order to make it so the subscriptions use the new access
      // token.
      socketRef.current.close(_graphqlWs.CloseCode.Forbidden, "New access token fetched");
    }
  }),
  handleError: function handleError(err) {
    _jsTools.authConsole.error("Cannot fetch access token in TokenFetchLink. Redirecting to logout.", err);
    (0, _redirectToLogout["default"])({
      withBack: true
    });
  },
  getOperationContext: function getOperationContext(operation) {
    if (!isSubscription(operation)) {
      return {
        headers: getExtraHeaders()
      };
    }
  }
});

// A HttpLink that attaches the authorization headers
var httpLink = exports.httpLink = (0, _apolloLinkContext.setContext)(function () {
  return (
    // By returning a function, we make sure the headers are computed at every request
    function () {
      var headers = getExtraHeaders();
      if (headers) {
        return {
          headers: headers
        };
      }
    }
  );
}).concat(new _client.HttpLink({
  uri: GRAPHQL_MIDDLEWARE_URL
}));

// A WebSocketLink that attaches the authorization headers
// https://www.apollographql.com/docs/react/api/link/apollo-link-subscriptions/
var graphqlWsLink = exports.graphqlWsLink = new _subscriptions.GraphQLWsLink(
// https://the-guild.dev/graphql/ws/docs/interfaces/client.ClientOptions
(0, _graphqlWs.createClient)({
  url: GRAPHQL_MIDDLEWARE_URL.replace("http", "ws"),
  // Setting lazy makes sure the connectParams function is called after the
  // ACCESS_TOKEN is fetched. Needed because of the queuing done by TokenFetchLink.
  lazy: true,
  // Needs to be e function in order to be lazily called
  connectionParams: getExtraHeaders,
  // https://github.com/enisdenjo/graphql-ws/issues/105
  // https://the-guild.dev/graphql/ws/recipes#client-usage-with-retry-on-any-connection-problem
  // By default the client will immediately fail on any non-fatal `CloseEvent`
  // problem thrown during the connection phase. By activating retry on any
  // connection problem, the client will try again which will refresh the
  // connection params with the new access token.
  shouldRetry: function shouldRetry() {
    return true;
  },
  on: {
    connected: function connected(socket) {
      socketRef.current = socket;
      _jsTools.authConsole.log("Connected to the GraphQL WS server", socket);
    },
    closed: function closed(event) {
      _jsTools.authConsole.log("Closed WS server", event, new Date());
    }
  }
}));

// The multiplexing link that selects the correct transport for the correct
// GraphQL Operation
var splitTransportLink = exports.splitTransportLink = (0, _client.split)(
// IF
isSubscription,
// THEN
graphqlWsLink,
// ELSE
httpLink);
var errorLink = exports.errorLink = (0, _error.onError)(function (_ref5) {
  var graphQLErrors = _ref5.graphQLErrors,
    networkError = _ref5.networkError;
  if (graphQLErrors) {
    graphQLErrors.forEach(function (_ref6) {
      var message = _ref6.message,
        locations = _ref6.locations,
        path = _ref6.path;
      return console.error("[GraphQL error]: Message: ".concat(message, ", Location: ").concat(locations, ", Path: ").concat(path));
    });
  }
  if (networkError) {
    console.error("[Network error]: ".concat(networkError));
  }
});